import { api } from '../../../shared/api/client';

export const createDeposit = (data) => api.post('/deposit/createDeposit', data);
export const getDepositHistory = (params = {}) => api.post('deposit/getDepositHistory', params);
export const getPaymentMethods = () => api.get('deposit/payment-methods');
export const createWithdrawal = (data = {}) => api.post('withdraw/createWithdrawal', data);
export const getBankWithdraw = () => api.get('withdraw/getBankWithdraw');
export const getWithdrawals = (params = {}) => api.post('withdraw/getWithdrawals', params);

export const adminCreateDeposit = (data) => api.post('admin/deposit/createDeposit', data);
export const getAllDeposits = (params = {}) => api.post('admin/deposit/getAllDeposits', params);
export const updateDepositStatus = (data) => api.post('admin/deposit/updateDepositStatus', data);
export const getImageQrCode = (id = {}) => api.get('admin/withdraw/getImageQrCode', { params: { id } });
export const adminGetWithdrawals = (params = {}) => api.post('admin/withdraw/getWithdrawals', params);
export const updateWithdraw = (id, params = {}) => api.post('admin/withdraw/updateWithdraw', params, { params: { id } });
